import { FullLoadingSpinner } from '@capitalise/ui-design-system';
import { lazy, Suspense } from 'react';

const lazyWithRetry = (componentImport) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem('page-has-been-force-refreshed') || 'false',
    );

    try {
      const component = await componentImport();

      window.localStorage.removeItem('page-has-been-force-refreshed');

      return component;
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        window.localStorage.setItem('page-has-been-force-refreshed', 'true');
        return window.location.reload();
      }
      throw error;
    }
  });

export default function withLoadable(loader) {
  const Component = lazyWithRetry(loader);
  return (props) => (
    <Suspense fallback={<FullLoadingSpinner />}>
      <Component {...props} />
    </Suspense>
  );
}
